import React from "react";
import { CLAMP_CODES, clampLabel } from "@/constants/coverCodes";
import { useT } from "@/i18n/LanguageContext";

// Fixed-vocabulary clamp drop list (F-Clamp / R-Clamp). Keeps a legacy value that is not in the list.
export function ClampSelect({ value, onChange, testid, disabled = false, className = "", allowEmpty = true }) {
  const { t, lang } = useT();
  const v = value ?? "";
  return (
    <select
      data-testid={testid}
      value={v}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      className={`font-mono text-sm w-full border border-slate-300 rounded-md h-10 px-2 bg-white ${disabled ? "bg-slate-50 cursor-not-allowed" : ""} ${className}`}
    >
      {allowEmpty && <option value="">{t("— select —")}</option>}
      {CLAMP_CODES.map((opt) => (
        <option key={opt} value={opt}>{clampLabel(opt, lang)}</option>
      ))}
      {v && !CLAMP_CODES.includes(v) && <option value={v}>{v} (legacy)</option>}
    </select>
  );
}
